var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contact-custom-fields'),_vm._v(" "),_c('contact-types'),_vm._v(" "),_c('contact-tags')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }